import { put, call, take, fork } from 'redux-saga/effects'
import { assignmentPatchService } from '../../api/assignment'
import { assignmentPatchSuccess } from '../../reducers/assignment/action'
import { ASSIGNMENT_PATCH } from '../../reducers/assignment/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* assignmentPatchFlow(payload) {
  try {
    const { content, callback } = payload
    yield call(assignmentPatchService, content)

    yield put(assignmentPatchSuccess(content))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* assignmentPatchWatcher() {
  while (true) {
    const action = yield take(ASSIGNMENT_PATCH)
    const { payload } = action

    yield fork(generalSaga, assignmentPatchFlow, payload)
  }
}
